import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { AppConfigurationService } from './app-configuration.service'

@Injectable({
  providedIn: 'root'
})
export class ReferencesService {
  constructor(
    private http: HttpClient,
    private appConfigurationService: AppConfigurationService
  ) {}
  public getCartReferences(referenceType: string, cartCode: string): Observable<any> {
    const baseSiteUrl: string = this.appConfigurationService.getBaseSiteUrl()
    const getUrl = `${baseSiteUrl}/cart/${cartCode}/references?fields=DEFAULT,references(target(images(FULL)))&referenceType=${referenceType}`
    return this.http.get<any>(getUrl)
  }
}
